// extracted by mini-css-extract-plugin
export default {"device":"styles_device__nv7fC","positionTop":"styles_positionTop__qmKw9"};